import { isLocalApi } from 'utils/localApi';

// Set REACT_APP_LOCAL_API_CONTACTS=true in .env.local for the local API.
export const CONTACTS_LOCAL_API_REQUESTS = isLocalApi(
  process.env.REACT_APP_LOCAL_API_CONTACTS
);
